import React from 'react';
import { PrivateDashboardFilterBar } from '@/features/dashboard/components/DashboardFilterBar/components/PrivateDashboardFilterBar';
import {
  DashboardType,
  EMBEDDED_DASHBOARD,
  PRIVATE_DASHBOARD,
} from '@/features/dashboard/types';
import { EmbeddedDashboardFilterBar } from '@/features/dashboard/components/DashboardFilterBar/components/EmbeddedDashboardFilterBar';

export const DashboardFilterBar: React.FC<{
  dashboardType: DashboardType;
  updateDashboardFilters: F0;
}> = ({ dashboardType, updateDashboardFilters }) => {
  return (
    <>
      {dashboardType === PRIVATE_DASHBOARD && (
        <PrivateDashboardFilterBar
          updateDashboardFilters={updateDashboardFilters}
        />
      )}
      {/* TODO embedded dashboard filters will be here */}
      {dashboardType === EMBEDDED_DASHBOARD && <EmbeddedDashboardFilterBar />}
    </>
  );
};
